import type { ModeloDaFace, VistaDaFace } from "@bookdental/schemas";

// Desenhos da face em public/face/<modelo>-<vista>.webp, todos no quadro 520 × 760 (QUADRO_DA_FACE):
// traço escuro em fundo transparente — no modo escuro o componente inverte a cor.

const ARQUIVO_DA_VISTA: Record<VistaDaFace, string> = {
  FRENTE: "frente",
  PERFIL_DIREITO: "perfil-direito",
  PERFIL_ESQUERDO: "perfil-esquerdo",
};

/** Modelos com desenho pronto — o seletor só aparece quando houver mais de um. */
export const MODELOS_DISPONIVEIS: ModeloDaFace[] = ["FEMININO", "MASCULINO"];

export const modeloValido = (m: ModeloDaFace | null | undefined): ModeloDaFace =>
  m && MODELOS_DISPONIVEIS.includes(m) ? m : MODELOS_DISPONIVEIS[0];

/** Modelo do plano: o escolhido, senão o do sexo do paciente. */
export const modeloDoPlano = (escolhido: ModeloDaFace | null | undefined, sexo: string | null | undefined) =>
  modeloValido(escolhido ?? (sexo === "M" ? "MASCULINO" : "FEMININO"));

export const imagemDaFace = (modelo: ModeloDaFace, vista: VistaDaFace) =>
  `/face/${modelo.toLowerCase()}-${ARQUIVO_DA_VISTA[vista]}.webp`;
